import { ChatComposeBoxAddAttachmentMenuItem } from '@glade-ai/chat-plugin';
import { type ComponentPropsWithoutRef, type FC, forwardRef } from 'react';

import MediaRecorder from '@/components/MediaRecorder';
import { mixpanelTrack } from '@/providers/Mixpanel';

type AddSoundPopoverContentProps = {
  onSubmit: (url: string) => void;
  disabled: boolean;
  onFileUploadClicked: () => void;
};

const ADD_SOUND_LABEL = 'Audio';
const ADD_SOUND_ICON = 'ph--microphone--regular';

export const AddSoundMenuItem = forwardRef<
  HTMLDivElement,
  Omit<ComponentPropsWithoutRef<typeof ChatComposeBoxAddAttachmentMenuItem>, 'icon' | 'label'>
>((props, forwardedRef) => (
  <ChatComposeBoxAddAttachmentMenuItem {...props} ref={forwardedRef} icon={ADD_SOUND_ICON} label={ADD_SOUND_LABEL} />
));
AddSoundMenuItem.displayName = 'AddSoundMenuItem';

export const AddSoundPopoverContent: FC<Omit<AddSoundPopoverContentProps, 'disabled'>> = ({
  onSubmit,
  onFileUploadClicked,
}) => {
  const handleSubmit = (url: string): void => {
    mixpanelTrack('InputComposer - audio recorded');
    onSubmit(url);
  };

  return <MediaRecorder onSubmit={handleSubmit} setPopoverOpen={() => {}} onFileUploadClicked={onFileUploadClicked} />;
};
